<template lang="pug">
        div.summaryContainer
            div(v-if="campLoader")
                Loader
            div
                div.card.tw-my-4
                  div.tw-flex.tw-gap-2.tw-justify-between.tw-items-center
                    div.tw-flex.tw-gap-3
                      div.tw-flex.tw-gap-6
                        div
                          div.tw-ml-2.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") Date Range
                          div
                              date-range-picker.customDateRange(v-model="dateRange"
                              opens='right'
                              :autoApply="true"
                              :max-date="maxData"
                              :locale-data="{format:'dd mmm yyyy'}"
                              @update="checkPageType()"
                              :show-dropdowns="true"
                          )
                        div 
                          div.tw-ml-1.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") AD/Campaign Type
                          div
                            treeselect(:options="viewCampaignTypeList" :limit="1" v-model="selectedCampaginType" 
                              :multiple="true" @input="getPreviewTableData" )
                                div(slot="value-label" slot-scope="{ node }") {{ node.raw.label }}
                        div
                          div.tw-ml-1.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") Campaign Status
                          div  
                            treeselect(:options="viewCampaignStatusList" :limit="1" v-model="selectedCampaginStatus" 
                              :multiple="true" @input="getPreviewTableData")
                                div(slot="value-label" slot-scope="{ node }") {{ node.raw.label }}

                        div(v-if="!viewTableData.isDefault && !viewReportLoader && !isDefaultReport")
                          div
                            .tw-ml-2.tw-mb-1.tw-font-medium.tw-text-sm(class="tw-text-[#1e1e1e]") Filter By
                            #customFilterDropdown
                              select.tw-rounded.tw-relative.tw-w-36.tw-text-sm(
                                v-model="filterBy",
                                class="tw-text-[#1e1e1e] tw-py-[5px] 2xl:tw-w-48",
                                @click="handleIsFilter"
                              )
                                option(value="", disabled) Filter By
                                option(value="performance") Performance Metrics
                                option(value="campaign") Campaign Name

                            .tw-relative(v-if="isFilter")
                              .tw-shadow-2xl.bg-white.tw-rounded.p-3.tw-absolute.tw-top-full.tw-right-0.tw-mt-2.tw-z-10.border-2(
                                v-if="filterBy === 'performance' || filterBy === 'campaign'"
                              )
                                div(v-if="filterBy === 'performance'")
                                  #customFilterDropdown.tw-flex.tw-gap-2(
                                    v-if="numericFiltersFields && numericFiltersFields.fields"
                                  )
                                    select.tw-py-1.tw-rounded.tw-text-sm.tw-w-36(
                                      v-model="selectedNumericCampaignValue",
                                      class="tw-text-[#1e1e1e] 2xl:tw-w-48",
                                      @click="handleNumericFilterModal(selectedNumericCampaignValue)"
                                    )
                                      option(
                                        v-for="(item, index) in numericFiltersFields.fields",
                                        :key="index",
                                        :value="item"
                                      ) {{ item.value }}

                                    select.tw-capitalize.tw-h-10.tw-rounded.tw-text-sm.tw-w-36(
                                      class="tw-text-[#1e1e1e] 2xl:tw-w-48",
                                      v-model="selectedNumericMatricsValue",
                                      @click="handleNumericMatricFilterModal(selectedNumericMatricsValue)"
                                    )
                                      option(
                                        v-for="(item, index) in numericFiltersFields.operations",
                                        :key="index",
                                        :value="item"
                                      ) {{ item }}

                                    input.tw-h-9.tw-px-1.tw-mr-3.tw-bg-white.tw-text-sm.tw-rounded.block.tw-w-36.tw-text-sm(
                                      class="tw-text-[#1e1e1e] 2xl:w-48 focus:tw-ring-0 focus:tw-outline-none disabled:tw-opacity-50 focus:tw-border-[#B3B2B9] tw-border-[#B3B2B9] tw-border-[1px] disabled:tw-cursor-not-allowed",
                                      v-model="matricsInputValue",
                                      type="number",
                                      placeholder="Value"
                                    ) 

                                  footer.rounded-lg.tw-sticky.tw-bottom-0.tw-w-full.tw-py-4.tw-mb-0.tw-flex.tw-justify-end.tw-px-3
                                    button.tw-h-8.text-primary_brand.tw-mr-2.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                                      class="tw-border-[1px] tw-border-[#275659] focus:tw-border-[#275659] focus:tw-outline-none focus:tw-shadow-none"
                                      @click="clearFilter"
                                    ) 
                                      
                                      span Cancel
                                    button.tw-h-8.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                                      class="hover:tw-bg-primary_brand-80",
                                      @click="postNumericalFilters()"
                                    ) 
                                      
                                      span Add Filter

                                div(v-if="filterBy === 'campaign'")
                                  #customFilterDropdown.tw-flex.tw-gap-2(
                                    v-if="stringFiltersFields && stringFiltersFields.fields"
                                  )
                                    select.tw-rounded.tw-py-1.tw-w-36.tw-text-sm(
                                      v-model="selectedStringCampaignValue",
                                      class="tw-text-[#1e1e1e] 2xl:tw-w-48",
                                      @click="handleStringFilterModal(selectedStringCampaignValue)"
                                    )
                                      option(
                                        v-for="(data, index) in stringFiltersFields?.fields",
                                        :key="index",
                                        :value="data"
                                      ) {{ data.value }}

                                    select.tw-capitalize.tw-h-10.tw-rounded.tw-py-1.tw-text-sm.tw-w-36(
                                      v-model="selectedStringMatricsValue",
                                      class="tw-text-[#1e1e1e] 2xl:tw-w-48",
                                      @click="handleStringMatricsFilterModal(selectedStringMatricsValue)"
                                    )
                                      option(
                                        v-for="(data, index) in stringFiltersFields?.operations",
                                        :key="index",
                                        :value="data"
                                      ) {{ data }}

                                    input.tw-h-9.tw-px-1.tw-mr-3.tw-bg-white.tw-rounded.tw-block.tw-text-sm.tw-w-36(
                                      class="tw-text-[#1e1e1e] 2xl:tw-w-48 focus:ring-0 focus:tw-outline-none disabled:tw-opacity-50 focus:tw-shadow-none disabled:cursor-not-allowed focus:tw-border-[#B3B2B9] tw-border-[#B3B2B9] tw-border-[1px]",
                                      v-model="StringMatricsInputValue",
                                      type="text",
                                      placeholder="Value"
                                    ) 

                                  footer.tw-rounded-lg.tw-sticky.tw-bottom-0.tw-flex.tw-justify-end.tw-bg-white.tw-w-full.tw-py-4.tw-mb-0.tw-px-3
                                    button.tw-h-8.tw-text-primary_brand.tw-mr-2.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(class="tw-border-[1px] tw-border-[#275659] focus:tw-border-[#275659] focus:tw-outline-none focus:tw-shadow-none" @click="clearFilter")   
                                      span Cancel
                                    button.tw-h-8.text-white.tw-bg-primary_brand.tw-font-medium.tw-rounded.tw-text-md.tw-px-3.tw-text-center.tw-inline-flex.tw-items-center(
                                      class="hover:tw-bg-primary_brand-80",
                                      @click="handlePostStringFilters()"
                                    ) 
                                      
                                      span Add Filter
    
                        div
                          div.tw-ml-1.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") View By
                          div
                            treeselect(:options="viewByList" v-model="selectedViewBy" :disabled="isViewReport"
                              :multiple="true")
                                //- div(slot="value-label" slot-scope="{ node }") {{ node.raw.label }}
                    div.tw-flex
                      button(class="btn primarycolor d-flex align-items-center" @click="handleSaveAndUpdateButton" v-if="viewReportType=='preview' || isEditReport" ) 
                        b-spinner(v-if="isSaveReport " :disabled="isSaveReport" small class="mr-2") 
                        span {{isEditReport?'Update':'Save'}}
                      router-link(to="/custom-report" class="tw-cursor-pointer")
                        button.text-white.tw-py-2.tw-px-3.tw-rounded.tw-ml-3(class="tw-bg-[#FCB117] tw-font-[500] 2xl:tw-text-[14px] tw-text-[12px]") Back     
                  
                  div.tw-flex
                    .tw-flex.tw-flex-wrap.tw-gap-2.tw-pt-2(
                        v-if="storeNumericFilterValue?.length || storeStringFilterValue?.length",
                        style="border-top: 1px solid #d4d4d4"
                      )
                        .tw-flex.tw-flex-wrap.tw-gap-2(v-if="storeNumericFilterValue?.length") 
                          div(v-for="(item, index) in storeNumericFilterValue", :key="index") 
                            
                            span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-py-2.tw-px-3.tw-mb-2.text-sm.tw-text-primary_brand.tw-rounded-md(
                              v-for="(data, index) in item",
                              :key="index",
                              class="tw-bg-[#E7EEEE] tw-font-[500]"
                            )
                              span.capitalize {{ data.field.value }}: {{ data.operation }}&nbsp;
                              span {{ data.value }}
                              button.tw-inline-flex.tw-items-center.p-1.ms-2.tw-text-sm.tw-text-primary_brand.tw-bg-transparent.tw-rounded-sm.tw-font-semibold(
                                type="button",
                                data-dismiss-target="#badge-dismiss-default",
                                aria-label="Remove",
                                @click="RemoveFilterBadgeValue(data)"
                              )
                                svg.tw-w-2.tw-h-2(
                                  aria-hidden="true",
                                  xmlns="http://www.w3.org/2000/svg",
                                  fill="none",
                                  viewBox="0 0 14 14"
                                )
                                  path(
                                    stroke="currentColor",
                                    stroke-linecap="round",
                                    stroke-linejoin="round",
                                    stroke-width="2",
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                  )
                                span.sr-only Remove badge

                    .tw-flex.tw-flex-wrap.tw-gap-2.tw-pt-2.tw.ml-2(v-if="storeStringFilterValue?.length") 
                      div(v-for="(item, index) in storeStringFilterValue", :key="index")
                        span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-py-2.tw-px-3.tw-mb-2.tw-text-sm.tw-text-primary_brand.tw-font-medium.tw-rounded-md(
                          v-for="(data, index) in item",
                          :key="index",
                          class="tw-bg-[#E7EEEE]"
                        )
                          span.capitalize {{ data.field.value }}: {{ data.operation }}&nbsp;
                          span {{ data.value }}
                          button.tw-inline-flex.tw-items-center.tw-p-1.ms-2.tw-text-sm.tw-text-primary_brand.tw-bg-transparent.tw-rounded-sm(
                            type="button",
                            data-dismiss-target="#badge-dismiss-default",
                            aria-label="Remove",
                            @click="RemoveFilterBadgeValue(data)"
                          )
                            svg.tw-w-2.tw-h-2(
                              aria-hidden="true",
                              xmlns="http://www.w3.org/2000/svg",
                              fill="none",
                              viewBox="0 0 14 14"
                            )
                              path(
                                stroke="currentColor",
                                stroke-linecap="round",
                                stroke-linejoin="round",
                                stroke-width="2",
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                              )
                            span.sr-only Remove badge

                  div.tw-flex.tw-gap-2.tw-mt-2(v-if="isViewReport && viewTableData?.selected_filters?.filters")
                    span#badge-dismiss-default.tw-inline-flex.tw-items-center.tw-py-2.tw-px-3.tw-mb-2.tw-text-sm.tw-text-primary_brand.tw-font-medium.tw-rounded-md(
                              v-for="(data, index) in viewTableData.selected_filters.filters",
                              :key="index",
                              class="tw-bg-[#E7EEEE]"
                            )
                              span.capitalize {{ data.field.value }}: {{ data.operation }}&nbsp;
                              span {{ data.value }}
              

            div.card.tw-mb-4 
              div
                div.tw-flex.tw-justify-between.tw-pb-2.tw-mb-4(class=" tw-border-b-[1px] tw-border-[#D4D4D4]")
                    span(class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2") {{viewTableData?.report_name}} 
                    button.text-white.tw-py-2.tw-px-3.tw-rounded.tw-ml-3(class="tw-bg-[#FCB117] tw-font-[500] 2xl:tw-text-[14px] tw-text-[12px]" @click="handleDownloadTable") Download      
              div.tw-w-full(v-if="Object.keys(viewTableData).length")
                  table#campaignDataTable.tw-w-full
                      thead
                          tr
                              th(v-for="(item, index) in viewTableData.headers" :key="index")
                                  span {{item.value}}
                      tbody
                          tr(v-for="(item, idx) in viewTableData.data" :key="idx" v-if="item.date !='Total' ")  
                              td(v-for="(head, index) in viewTableData.headers" :key="index")
                                  span {{item[head.key]}}

                      tfoot
                          tr(v-for="(item, index) in viewTableData.data" :key="index" v-if="String(item.date).includes('Total')")  
                              td(v-for="(head, index) in viewTableData.headers" :key="index")
                                  span {{item[head.key]}}
              div(v-else)
                div(v-if="viewReportLoader" class="onLoadingData mt-3") Loading...
                div.tw-p-4.tw-mb-4.tw-text-sm.tw-rounded-lg(class="tw-text-[red] tw-bg-red-10" v-else )
                    span.tw-font-medium No Data in Table!                       
    </template>

<script>
import moment from "moment";
import Loader from "../../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { watch } from "vue";
import Multiselect from "vue-multiselect";

export default {
  name: "PerformanceSummary",
  components: {
    Loader,
    Treeselect,
    Multiselect,
  },
  data() {
    return {
      campLoader:false,
      isFilter:false,
      dateRange: {
				startDate: moment().subtract(15,"days").format("YYYY-MM-DD"),
				endDate: moment().format("YYYY-MM-DD"),
			},   
      // Loader variable 
      maxData: new Date(),
      viewReportLoader:false,
      viewReportId: this.$route.params.report_id,
      viewReportType: this.$route.params.type,
      viewReportPayload:[],
      viewTableData:{},
      isSaveReport:false,
      isDefaultReport:false,
      viewByList:[
        {
          id: 'daily',
          label: 'Daily',
          isDisabled: true
        }
      ],
      selectedViewBy:['daily'],
      selectedCampaginType: [],
      viewCampaignTypeList:[],
      selectedCampaginStatus:[],
      viewCampaignStatusList:[],
      isViewReport: true,
      viewSelectedChannel: 'amazon',
      channelMapper:{
          d9e7f17809ff4695b28f538ae8f08b36:'amazon',
          e165604721bc4bf2b1538816285285f5:'flipkart'
      },
      //filter by section 
      filterBy: "",
      selectedNumericCampaignValue: "ACOS",
      numericFiltersFields: [],
      selectedNumericMatricsValue: "greater than",
      matricsInputValue: "",
      selectedStringCampaignValue: "Campaign Name",
      stringFiltersFields: [],
      selectedStringMatricsValue: "contains",
      StringMatricsInputValue: "",
      storeNumericFilterValue: [],
      storeStringFilterValue: [],
      // edit section
      isEditReport:false

    };
  },

  mounted() {
   this.checkPageType();
    // console.log("check the report", this.getReportId.params.report_id)
    // this.getPreviewTableData();

    // this.$watch(
    //   "allAsinCategory",
    //   (newVal) => {
    //     if (newVal && Object.keys(newVal).length) {
    //       this.treeSelectData = this.transformToTreeSelect(newVal);
    //     }
    //   },
    //   { immediate: true }
    // );
  },

  methods: {
    checkPageType(){
      if(this.viewReportType==='report'){
        this.isViewReport = true
        this.getReportTableData();

      }
      else if(this.viewReportType==='preview'||this.viewReportType==='update' ){
        this.isViewReport = false
        // if(this.viewReportType=='update'){
        //   this.isEditReport = true
        // }
        this.getReportPayloadData();
      }
      this.formatDateRange();
    },

    formatDateRange() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
    },

    formatDates() {
      this.formatDateRange();
      this.getPreviewTableData();
      // this.getAsinReportData();
    },

    getFilterData(){
      const url = "/api/v2/custom_report/filters?channel="+this.viewSelectedChannel
      this.viewCampaignTypeList  = []
      this.viewCampaignStatusList = []
      this.$http.get(url).then((res)=>{
        if(!this.isViewReport && !JSON.parse(this.viewReportPayload).isDefault){ // custom report at creation
          this.selectedCampaginStatus = []
          this.selectedCampaginType = []
          const temp = res.data.data.camp_type.map(data=>({id:data.key,label:data.value}))
          this.viewCampaignTypeList.push(...temp)
          const temp2 = res.data.data.camp_status.map(data=>({id:data.key,label:data.value}))
          this.viewCampaignStatusList.push(...temp2)
        }
        else{ // default report once new repport create
          if( this.viewTableData?.selected_filters?.camp_type.length){
            const temp =  res.data.data.camp_type.map(data=>({id:data.key,label:data.value,isDisabled:true}))
            this.viewCampaignTypeList.push(...temp)
            this.selectedCampaginType = this.viewTableData?.selected_filters?.camp_type
          }
          else{
            this.selectedCampaginType = ['']
            this.viewCampaignTypeList = [{id:'',label:'All',isDisabled:true}]
          }
          if(this.viewTableData.selected_filters?.camp_status.length){
            const temp2 = this.viewTableData.selected_filters?.camp_status==[]?[{id:'',label:'All',isDisabled:true}]:res.data.data.camp_status.map(data=>({id:data.key,label:data.value,isDisabled:true}))
            this.viewCampaignStatusList.push(...temp2)
            this.selectedCampaginStatus = this.viewTableData.selected_filters?.camp_status==[]?['']:this.viewCampaignStatusList.filter(data => this.viewTableData.selected_filters?.camp_status.includes(data.label.toUpperCase())).map(data => data.id);
          }
          else{
            this.selectedCampaginStatus=['']
            this.viewCampaignStatusList =[{id:'',label:'All',isDisabled:true}]
          }

       
        }
        if(this.viewReportType=='update' && !this.isDefaultReport){
           this.isEditReport= true
        }
        if(this.isDefaultReport){ // default report
          this.selectedCampaginType = ['']
          this.selectedCampaginStatus = ['']
          this.viewCampaignTypeList = [{id:'',label:'All',isDisabled:true}]
          this.viewCampaignStatusList =[{id:'',label:'All',isDisabled:true}]

        }
      }).catch((res)=>{


      })
    },

    getReportPayloadData(){
      const url = "/api/v2/custom_report/data_save?id="+this.viewReportId
      this.viewReportLoader = true
      this.viewReportPayload = ''
      const payload = {}
      this.$http.get(url).then((res)=>{
        this.viewReportPayload = res.data.data.data
        this.isDefaultReport = JSON.parse(this.viewReportPayload).isDefault

        if(!this.viewReportPayload.isDefault){
          // console.log("check tehd channe", JSON.parse(this.viewReportPayload).channel[0])    
          this.viewSelectedChannel = this.channelMapper[JSON.parse(this.viewReportPayload).channel[0]]
          this.getFilterData();
        }
        this.viewReportLoader = false
        this.getPreviewTableData();
      }).catch(err=>{
        this.viewReportLoader = false
        console.log(err)
      })
    },

    getReportTableData(){
      this.viewReportLoader = true
      this.viewTableData ={}
      let url = "/api/v2/custom_report/view_report?id="+this.viewReportId;
      url += "&start_date="+moment(this.dateRange.startDate).format("YYYY-MM-DD")
      url += "&end_date="+moment(this.dateRange.endDate).format("YYYY-MM-DD")
      // $("#campaignDataTable").DataTable().destroy();
      this.$http.get(url).then((res) => {
          this.viewTableData = res.data.data;
          this.viewSelectedChannel = this.channelMapper[this.viewTableData?.platform[0]]
          this.isDefaultReport = this.viewTableData.isDefault

          this.viewReportLoader = false;
          this.getFilterData()
          // this.getReportTableData = false
          this.$nextTick(() => {
            this.processTable("#campaignDataTable");
          });

          // this.campLoader = false;
        })
        .catch((err) => {
          // this.campLoader = false;
          this.viewReportLoader = false
          console.log(err);
        });
    },
    getPreviewTableData() {
      // this.campLoader = true;
      this.viewReportLoader = true
      const url = "/api/v2/custom_report/report_preview";
      // $("#campaignDataTable").DataTable().destroy();
      if(this.isViewReport){
        return false;
      }
      this.viewTableData = {}
      const temp = JSON.parse(this.viewReportPayload)
      const payload = {...temp,
        "camp_type": this.selectedCampaginType.flat(),
        "camp_status": this.selectedCampaginStatus.flat(),
        "start_date" : this.dateRange.startDate,
        "end_date" : this.dateRange.endDate,
        "filters" : this.processFilterBy()
      }
      this.$http.post(url, payload).then((res) => {
          this.viewTableData = res.data.data;   
          if(!this.isDefaultReport)  {    
            this.numericFiltersFields=res.data.data?.numerical_filters[0];
            this.stringFiltersFields=res.data.data?.string_filters;
            this.selectedStringCampaignValue= this.stringFiltersFields?.fields[0];
            this.selectedNumericCampaignValue= this.numericFiltersFields?.fields[0];
          }
          this.$nextTick(() => {
            this.processTable("#campaignDataTable");
          });
          if ($.fn.DataTable.isDataTable('#capaignDataTable')) {
              $('#capaignDataTable').DataTable().destroy();
          }
          this.viewReportLoader = false
          // this.campLoader = false;
        })
        .catch((err) => {
          this.viewReportLoader = false
          // this.campLoader = false;
          console.log(err);
        });
    },

    processFilterBy(){
      let temp = []
      if(this.storeStringFilterValue){
        temp.push(this.storeStringFilterValue.flat());

      }
      if(this.storeNumericFilterValue){
        temp.push(this.storeNumericFilterValue.flat());
      }
      return temp.flat();
    },

    handleSaveAndUpdateButton(){
      if(this.isEditReport){
        this.updateReport();
      }
      else{
        this.saveReport();
      }
    },
    updateReport(){
            this.isSaveReport = true
            let url = "/api/v2/custom_report/edit_report"
            const temp = JSON.parse(this.viewReportPayload)
            const payload = {...temp,
              "camp_type": this.selectedCampaginType.flat(),
              "camp_status": this.selectedCampaginStatus.flat(),
              "start_date" : this.dateRange.startDate,
              "end_date" : this.dateRange.endDate,
              "filters" : this.processFilterBy()
            }
            this.$http.post(url,payload).then(res=>{
              this.isSaveReport = false
                this.$router.push('/custom-report')
            }).catch(err=>{console.log("err"); this.isSaveReport = false});
    },
 
    saveReport(){
      this.isSaveReport = true
      // if(!this.viewReportPayload.length){
      //   return false
      // }
      const url = "/api/v2/custom_report/new_report"
      const temp = JSON.parse(this.viewReportPayload)
      let payload = temp
      if(!temp.isDefault){
        payload= {...temp,
          "camp_type": this.selectedCampaginType.flat(),
          "camp_status": this.selectedCampaginStatus.flat(),
          "filters" : this.processFilterBy()

        }
      }
      this.$http.post(url,payload).then(res=>{
        this.$router.push('/custom-report');
        this.isSaveReport = false
      }).then(err=>{
      })
    },

    // filter by section
    handleIsFilter() {
      const existingValue = this.storeNumericFilterValue?.find(
        (item) => item[0]?.field === this.selectedNumericCampaignValue
      );

      if (existingValue) {
        this.selectedNumericMatricsValue = existingValue[0]?.operation;
        this.matricsInputValue = existingValue[0]?.value;
      }
      this.matricsInputValue = "";
      this.StringMatricsInputValue = "";
      this.isFilter = true;
    },

    clearFilter() {
      this.isFilter = false;
      this.matricsInputValue = "";
      this.StringMatricsInputValue = "";
    },

    handleFilterModal(
      data,
      storeFilterValue,
      selectedMatricsValueKey,
      matricsInputValueKey
    ) {
      if (data?.length <= 0) {
        return false;
      }

      let existingValue = storeFilterValue?.find(
        (item) =>
          item[0]?.field === data &&
          item[0]?.operation === this[selectedMatricsValueKey]
      );

      if (existingValue) {
        this[matricsInputValueKey] = existingValue[0]?.value;
      } else {
        this[matricsInputValueKey] = "";
      }
    },

    handleNumericFilterModal(data) {
      this.handleFilterModal(
        data,
        this.storeNumericFilterValue,
        "selectedNumericMatricsValue",
        "matricsInputValue"
      );
    },

    handleStringFilterModal(data) {
      this.handleFilterModal(
        data,
        this.storeStringFilterValue,
        "selectedStringMatricsValue",
        "StringMatricsInputValue"
      );
    },

    handleNumericMatricFilterModal(data) {
      let existingValue = this.storeNumericFilterValue?.find(
        (item) =>
          item[0]?.field === this.selectedNumericCampaignValue &&
          item[0]?.operation === data
      );
      if (existingValue) {
        this.matricsInputValue = existingValue[0]?.value;
      } else {
        this.matricsInputValue = "";
      }
    },

    handleStringMatricsFilterModal(data) {
      let existingValue = this.storeStringFilterValue?.find(
        (item) =>
          item[0]?.field === this.selectedStringCampaignValue &&
          item[0]?.operation === data
      );
      if (existingValue) {
        this.StringMatricsInputValue = existingValue[0]?.value;
      } else {
        this.StringMatricsInputValue = "";
      }
    },

    handlePostFilters({
      selectedCampaignValue,
      selectedMatricsValue,
      matricsInputValue,
      storeFilterValue,
    }) {
      if (!matricsInputValue) {
        return false;
      }
      let existingFilter = storeFilterValue?.find(
        (item) =>
          item[0]?.field === selectedCampaignValue &&
          item[0]?.operation === selectedMatricsValue
      );

      if (existingFilter) {
        existingFilter[0].value = isNaN(matricsInputValue)
          ? matricsInputValue
          : parseFloat(matricsInputValue);
      } else {
        storeFilterValue.push([
          {
            operation: selectedMatricsValue,
            field: selectedCampaignValue,
            value: isNaN(matricsInputValue)
              ? matricsInputValue
              : parseFloat(matricsInputValue),
          },
        ]);
      }
    },

    postNumericalFilters() {
      this.handlePostFilters({
        selectedCampaignValue: this.selectedNumericCampaignValue,
        selectedMatricsValue: this.selectedNumericMatricsValue,
        matricsInputValue: this.matricsInputValue,
        storeFilterValue: this.storeNumericFilterValue,
      });
      this.isFilter = false;
      this.getPreviewTableData();
    },

    handlePostStringFilters() {
      if (!this.StringMatricsInputValue) {
        return false;
      }
      this.storeStringFilterValue.push([
        {
          operation: this.selectedStringMatricsValue,
          field: this.selectedStringCampaignValue,
          value: this.StringMatricsInputValue,
        },
      ]);      
      this.isFilter = false;
      this.getPreviewTableData();
    },

    removeFilterValue(storeFilterValue, data) {
      const index = storeFilterValue
        .flat()
        .findIndex(
          (item) =>
            item?.field === data?.field &&
            item?.operation === data?.operation &&
            item?.value === data?.value
        );

      if (index !== -1) {
        storeFilterValue.splice(index, 1);
      }
    },

    RemoveFilterBadgeValue(data) {
      this.removeFilterValue(this.storeNumericFilterValue, data);

      for (let i = 0; i < this.storeStringFilterValue?.length; i++) {
        const itemArray = this.storeStringFilterValue[i];
        const matchIndex = itemArray.findIndex(
          (item) =>
            item?.field === data?.field &&
            item?.operation === data?.operation &&
            item?.value === data?.value
        );

        if (matchIndex !== -1) {
          this.storeStringFilterValue.splice(i, 1);
          break;
        }
      }
      this.getReportPayloadData();
    },
    RemoveAllFilterBadgeValue() {
      this.storeNumericFilterValue = [];
      this.storeStringFilterValue = [];
    },

    // filter by end 
    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },

    handleDownloadTable() {
      let url = "/api/v2/amazon/report_download";
      const payload = {
        headers: this.viewTableData.headers,
        name: this.viewTableData.report_name,
        data: this.viewTableData.data,
      };

      this.$http.post(url, payload).then((res) => {
          // console.log(":res",res.data.data)
          if(res){window.location = res.data.data;}
        }).catch((err) => {
          console.error(err);
        });
    },


    

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #065559;
}

input:checked + .slider::before {
  transform: translateX(24px);
}

#customFilterDropdown select:focus {
  border-color: #b3b2b9 !important;
  box-shadow: none !important;
}

#customFilterDropdown select {
  border-color: #b3b2b9 !important;
  background: white !important;
  height: 35px !important;
}

@media (max-width: 1280px) {
  #customFilterDropdown select {
    height: 35px;
    padding-top: 1px;
    font-size: 13px;
  }

  #customFilterDropdown input {
    height: 35px;
  }
}
</style>
<style lang="scss" scoped>
.card {
  border-radius: 0.7rem;
  border: none;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #fff;
}
.customMultiselectCommon .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselectCommon span.multiselect__single {
  display: flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customMultiselectCommon .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  font-family: "poppins";
  overflow-y: auto !important;
}

.customMultiselectCommon .multiselect__tags .multiselect__single {
  font-size: 14px !important;
}

.customMultiselectCommon .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselectCommon
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
  font-size: 14px !important;
}

/* width */
.customMultiselectCommon ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselectCommon ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselectCommon ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselectCommon ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselectCommon .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}
</style>
<style>
#customDropdown select:focus {
  border-color: #b3b2b9 !important;
  box-shadow: none !important;
}

#customDropdown select {
  border-color: #b3b2b9 !important;
}

input[type="text"]:focus {
  box-shadow: none !important;
}
.vue-treeselect__control {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  border: 1px solid #b3b2b9 !important;
  padding: 0px !important;
}

.vue-treeselect__multi-value {
  min-width: 200px;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 0px !important;
}

@media (max-width: 1280px) {
  .vue-treeselect__control {
    height: 34px !important;
    padding: 0px !important;
    font-size: 13px !important;
  }

  .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value
    .vue-treeselect__input-container {
    padding: 0px !important;
  }

  #customDropdown select {
    height: 34px;
    padding-top: 1px;
    font-size: 13px;
  }

  #customDropdown input {
    height: 30px;
  }
}

table.dataTable .sorting {
  background-color: #0655591a !important;
  color: black !important;
  font-weight: 500 !important;
}
.min-width-column {
  min-width: 100px !important;
}
#asinDataTable tfoot,
#campaignDataTable tfoot {
  background-color: #0655591a !important;
  color: black !important;
}
</style>
<style scoped>
.toggle-switch-container {
  position: relative;
  width: 50px;
  height: 25px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #065559;
}

input:checked + .slider::before {
  transform: translateX(24px);
}

</style>
<style >
  .vue-treeselect__value-container{
  padding-left: 5px !important;
}
</style>
